import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  User, CreditCard, Heart, Briefcase, Star,
  Bell, Shield, HelpCircle, Settings, LogOut,
  ChevronRight, Edit, MapPin, Calendar, ArrowLeft, Crown, RefreshCw,

} from 'lucide-react';
import Swal from 'sweetalert2';
import axios from 'axios';
import '../../../../assets/css/screens/customer/dashboard/profile/profile.css';
import AppNavbar from '../../../../components/customer/dashboard/apphome/appnavbar/AppNavbar';
import AppContext from '../../../../context/AppContext';
import ProfileSkeleton from "../../../../components/skeltonloading/ProfileSkeleton";
// import SwitchModal from '../../../../components/customer/dashboard/profile/switchmodal/SwitchModal';
import ProfileUserCard from '../../../../components/customer/dashboard/profile/profilecard/ProfileCard';
import ProfileMenuGrid from '../../../../components/customer/dashboard/profile/profilegrid/ProfileGrid';
import ProfileMobileHeader from '../../../../components/customer/dashboard/profile/profilemobileheader/ProfileMobileHeader';
import ProfileMobileMenu from '../../../../components/customer/dashboard/profile/profilemobilemenu/ProfileMobileMenu';

const Profile = () => {
  const navigate = useNavigate();
  const { baseUrl, baseUrlForFile, authToken } = useContext(AppContext);
  const [loading, setLoading] = useState(true);
  // const [switchModal, setSwitchModal] = useState(false);

  const [user, setUser] = useState({
    name: '',
    email: '',
    phone: '',
    avatar: '',
    stats: {
      orders: 0,
      activeJobs: 0,
      reviews: 0
    }
  });
  

  const viewProfile = () => {
    setLoading(true);
    const token = localStorage.getItem("authToken")?.trim();

    axios.get(`${baseUrl}/customer/viewProfile`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
      .then((res) => {
        const data = res.data.customer;
        console.log("PROFILE API RESPONSE:", res.data);

        setUser({
          name: data.fullName || '',
          email: data.email || '',
          phone: data.phoneNumber || '',

          avatar: data.ProfileImage
            ? `${baseUrlForFile}/${data.ProfileImage}`
            : `https://ui-avatars.com/api/?name=${encodeURIComponent(data.fullName || "User")}`,

          stats: {
            orders: data.ordersCount || 0,
             activeJobs: data.activeJobsCount || 0,
            reviews: data.reviewsCount || 0
          }
        });
        setLoading(false);
      })
      .catch((err) => {
        console.log("Profile Error:", err.response?.data || err.message);
        setLoading(false);
      })
      
  };
  // delete account
  const handleDeleteProfile = () => {

    Swal.fire({
      title: 'Delete Account?',
      html: `
      <p style="line-height:1.6;">
        This action will permanently delete your account.<br/>
        <span style="color:red;font-weight:600;">
          This cannot be undone.
        </span>
      </p>
    `,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#dc2626',
      cancelButtonColor: '#6b7280',
      confirmButtonText: 'Yes, Delete'
    })

      .then(async (result) => {

        // sirf yes par delete hoga
        if (result.isConfirmed) {

          try {

            const res = await axios.delete(
              `${baseUrl}/customer/deleteAccount`,
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem("authToken")}`
                }
              }
            );

            console.log(res.data);

            if (res.data.success) {

              localStorage.clear();

              await Swal.fire({
                icon: 'success',
                title: 'Deleted!',
                text: 'Your account has been deleted successfully',
                timer: 1800,
                showConfirmButton: false
              });

              navigate("/");

            } else {

              Swal.fire({
                icon: 'error',
                title: 'Failed',
                text: res.data.message || 'Delete failed'
              });

            }

          } catch (err) {

            console.log("DELETE ERROR:", err.response?.data || err.message);

            // Swal.fire({
            //   icon: 'error',
            //   title: 'Server Error',
            //   text: 'Something went wrong'
            // });

          }

        }

      });

  };
  const menuItems = [
    {
      id: 'edit-profile',
      icon: <User size={22} />,
      title: 'Edit Profile',
      subtitle: 'Update your personal information',
      color: '#0491e1',
      route: '/profile-settings'
    },
    {
      id: 'subscription',
      icon: <Crown size={22} />,
      title: 'Subscription',
      subtitle: 'Manage your subscription plans',
      color: '#f59e0b',
      route: '/customer-subscription-history'
    },
    // {
    //   id: 'Hire-professional',
    //   icon: <CreditCard size={22} />,
    //   title: 'All professionals',
    //   subtitle: 'Manage your payment options',
    //   color: '#10b981',
    //   route: '/hire-professional'
    // },

    {
      id: 'Faqs',
      icon: <HelpCircle size={22} />,
      title: 'Faqs',
      subtitle: 'Answers to common questions.',
      color: '#ef4444',
      route: '/customer-faq'
    },
    {
      id: 'My Jobs',
      icon: <Briefcase size={22} />,
      title: 'My Jobs',
      subtitle: 'Track your jobs',
      color: '#3b82f6', // Blue
      route: '/my-jobs'
    },
//  {
//   id: 'card-history',
//   icon: <CreditCard size={22} />,
//   title: 'Card History',
//   subtitle: 'View your card transactions',
//   color: '#10b981',
//   route: '/customer-add-payment-card'
// },
    {
      id: 'notifications',
      icon: <Bell size={22} />,
      title: 'Notifications',
      subtitle: 'Manage notification preferences',
      color: '#06b6d4',
      route: '/customer-notifications'
    },
    // {
    //   id: 'security',
    //   icon: <Shield size={22} />,
    //   title: 'Privacy & Security',
    //   subtitle: 'Password and security settings',
    //   color: '#84cc16',
    //   route: '/privacy-security'
    // },
    {
      id: 'help',
      icon: <HelpCircle size={22} />,
      title: 'Help & Support',
      subtitle: 'Get assistance',
      color: '#6366f1',
      route: '/customer-support'
    },
    {
      id: 'settings',
      icon: <Settings size={22} />,
      title: 'Settings',
      subtitle: 'App preferences',
      color: '#64748b',
      route: '/customer-settings'
    }
  ];

  const handleMenuClick = (route) => {
    navigate(route);
  };


  // logout
  const handleLogout = () => {

    Swal.fire({
      title: 'Log Out?',
      text: 'Are you sure you want to log out?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#ef4444',
      cancelButtonColor: '#6b7280',
      confirmButtonText: 'Yes, Logout'
    })

      .then(async (result) => {

        // sirf yes par chalega
        if (result.isConfirmed) {

          try {

            const res = await axios.post(
              `${baseUrl}/customer/logout`,
              {},
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem("authToken")}`
                }
              }
            );

            console.log(res.data);

            if (res.data.success) {

              localStorage.clear();

              await Swal.fire({
                icon: 'success',
                title: 'Logged Out',
                text: 'You have been logged out successfully',
                timer: 1500,
                showConfirmButton: false
              });

              navigate("/");

            }

          } catch (err) {

            console.log("LOGOUT ERROR:", err.response?.data || err.message);

            // Swal.fire({
            //   icon: 'error',
            //   title: 'Error',
            //   text: 'Logout failed'
            // });

          }

        }

      });

  };

  const handleBack = () => {
    navigate(-1);
  };

  // fetch profile data 
  useEffect(() => {
    viewProfile();
  }, []);
if (loading) {
    return <ProfileSkeleton />;
}
  return (
    <>
      <AppNavbar />
      <div className="profile-page">


        {/* ════ HEADER ════ */}
        <div className="inbox-header">
          <button className="inbox-back-btn" onClick={handleBack}>
            <ArrowLeft size={24} />
          </button>
          <h2 className="inbox-title">Profile</h2>
        </div>

        {/* ════ DESKTOP: CARDS GRID ════ */}
        <div className="profile-desktop">

          {/* User Info Card */}
          <ProfileUserCard user={user} navigate={navigate} />

          {/* Menu Cards Grid */}
          <ProfileMenuGrid
            menuItems={menuItems}
            handleMenuClick={handleMenuClick}
            handleLogout={handleLogout}
            handleDeleteProfile={handleDeleteProfile}
          />
        </div>

        {/* ════ MOBILE: LIST VIEW ════ */}
        <div className="profile-mobile">

          <ProfileMobileHeader
            user={user}
            navigate={navigate}
            // setSwitchModal={setSwitchModal}
          />

          <ProfileMobileMenu
            menuItems={menuItems}
            handleMenuClick={handleMenuClick}
            handleLogout={handleLogout}
            handleDeleteProfile={handleDeleteProfile}
          />
        </div>

      </div>

      {/* {switchModal && (
        <SwitchModal
          onClose={() => setSwitchModal(false)}
          onSwitchNow={() => setSwitchModal(false)}
        />
      )} */}
    </>
  );
};

export default Profile;